import React from 'react'

function Offer() {
  return (
    <div>
      
      <h1 style={{marginTop: '100px', textAlign: 'center'}}>Job Offer</h1>
      <p>Details about the job offer will be displayed here.</p>
    </div>
  )
}

export default Offer
